<template>
  <div
    id="delivery-live-orders"
    class="page-content"
  >
    <div class="row">
      <div class="col-12">
        <incoming-grocery />
        <incoming-gourmet />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, nextTick, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const IncomingGrocery = defineAsyncComponent(() => import('./Grocery/IncomingGrocery.vue') as any);
const IncomingGourmet = defineAsyncComponent(() => import('./Gourmet/IncomingGourmet.vue') as any);

onMounted(async () => {
  const route = useRoute();
  await nextTick();
  util.moveScrollComponent(route.hash);
});
</script>
